import {inlineError, streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

@streamify('execute')
class GetLastContactDetailsSellerUseCase extends UseCase {
  constructor({getLastContactDetailsService}) {
    super({getLastContactDetailsService})

    this._getLastContactDetailsService = getLastContactDetailsService
  }

  @inlineError
  async execute() {
    const [error, contactDetailsVO] = await this._getLastContactDetailsService.execute()

    if (error) {
      return Promise.reject(error)
    }

    return contactDetailsVO ? contactDetailsVO.toJSON() : null
  }
}

export {GetLastContactDetailsSellerUseCase}
